import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

type FilterSelectOption = {
  label: string;
  value: string;
};

/* eslint-disable no-unused-vars */
type FilterSelectProps = {
  label: string;
  value: string;
  options: FilterSelectOption[];
  onChange: (value: string) => void;
  minWidth?: number;
};
/* eslint-enable no-unused-vars */

const FilterSelect = ({ label, value, options, onChange, minWidth = 180 }: FilterSelectProps) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  const labelId = `${label.replace(/\s+/g, '-').toLowerCase()}-label`;

  return (
    <FormControl size='small' sx={{ minWidth }}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select labelId={labelId} label={label} value={value} onChange={handleChange}>
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

FilterSelect.defaultProps = {
  minWidth: 180
};

export default FilterSelect;
